import { render, staticRenderFns } from "./footer-admin.vue?vue&type=template&id=f6e41f82&scoped=true&"
import script from "./footer-admin.vue?vue&type=script&lang=js&"
export * from "./footer-admin.vue?vue&type=script&lang=js&"
import style0 from "./footer-admin.vue?vue&type=style&index=0&id=f6e41f82&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e41f82",
  null
  
)

export default component.exports